
 console.log('START THE BLOG');

const postContainer = document.querySelector('post-container');
const headings = postContainer.querySelectorAll('h2, h3');
const contentsContainer = postContainer.querySelector('[data-contents]'); 
 
let list = document.createElement('ul');
let count = 0;


headings.forEach((title,index) => { 
    title.setAttribute('id', `content${index}`);
    //console.log(title, index);
    
  
    let titleListItem =  document.createElement('li');
    let titleLink =  document.createElement('a');
    titleLink.textContent = title.textContent;
    titleLink.setAttribute('href', `#content${index}`);

    if(title.tagName == 'H2') { 
        titleLink.classList.add('main-title');  
        list.appendChild(titleListItem);
        titleListItem.appendChild(titleLink);
   
    } else if (title.tagName === 'H3') { 
        let prevItem = list.lastChild;
        let sublist = prevItem.querySelector('ul');
    
        // If not, create a sublist and append it to the previous item
        if (!sublist) {
          sublist = document.createElement('ul');
          sublist.classList.add('subcontent');
          prevItem.appendChild(sublist);
        } 
        // Append the item to the sublist
        sublist.appendChild(titleListItem);
        titleListItem.appendChild(titleLink);
      }
 
      contentsContainer.innerHTML = list.innerHTML; 
}); 


/*** RESIZE BLOG IMAGES  *****/
const articleImages = document.querySelectorAll('article img');

articleImages.forEach((image)=> {
  const src =  image.getAttribute('src');
  //console.log(src);
  const newSrc = src.replace('480x480', '800x800').replace('640x640', '800x800');
  image.setAttribute('src', newSrc);
});
